import {DetailData} from "./structs/DetailData";
import {SearchData} from "./structs/SearchData";
import {StichwortData} from "./structs/StichwortData";
import {ResPriceData, ReqPriceData} from "./structs/PriceData";
import {ReqBookingData, ResBookingData} from "./structs/BookingData";

export interface ApiReqData {
    ctx?: string;
    tim?: number;
}

export class Api {
    static detailData(sendData: string, callback: (response: DetailData) => void): void {
        this._sendRequest('/detailData', sendData, callback)
    }

    static searchData(sendData: string, callback: (response: SearchData) => void): void {
        this._sendRequest('/searchData', sendData, callback)
    }

    static stichwortData(sendData: string, callback: (response: StichwortData) => void): void {
        this._sendRequest('/stichwortData', sendData, callback)
    }

    static priceRequest(sendData: ReqPriceData, callback: (response: ResPriceData) => void): void {
        this._sendRequest('/priceRequest', sendData, callback)
    }

    static bookingRequest(sendData: ReqBookingData, callback: (response: ResBookingData) => void): void {
        this._sendRequest('/bookingRequest', sendData, callback)
    }

    private static readonly _GetThreshold = 1000;

    private static _sendRequest(url: string, data: ApiReqData, callback: (response: any) => void): void
    private static _sendRequest(url: string, data: string, callback: (response: any) => void): void
    private static _sendRequest(url: string, data: any, callback: (response: any) => void): void {
        if (typeof (data) !== "object" || Array.isArray(data)) {
            data = {val: data};
        }
        data.ctx = location.pathname + location.search;
        data.tim = Date.now();
        const jsonData = JSON.stringify(data);
        if (url.length + jsonData.length > Api._GetThreshold) {
            //console.log("POST", url, jsonData);
            console.log("send:", data)
            fetch(url, {
                method: 'POST',
                body: jsonData,
                headers: {
                    'Content-Type': 'application/json'
                }
            })
                .then(response => {
                    if (response.status != 200) {
                        console.error("Error:", response.status, location.origin + url);
                        return {};
                    }
                    return response.json();
                })
                .then(r => {
                    console.log("recv:", r);
                    callback(r);
                })
                .catch(error => console.error('Error:', error));
        } else {
            // noinspection JSDeprecatedSymbols
            url += '?a=' + btoa(unescape(encodeURIComponent(jsonData)));
            //console.log("GET", url);
            console.log("send:", data)
            fetch(url)
                .then(response => {
                    if (response.status != 200) {
                        console.error("Error:", response.status, location.origin + url);
                        return {};
                    }
                    return response.json();
                })
                .then(r => {
                    console.log("recv:", r);
                    callback(r);
                })
                .catch(error => console.error('Error:', error));
        }
    }
}
